import React from 'react';
import { FileText, X, Image as ImageIcon, FileSpreadsheet } from 'lucide-react';
import { fmtBytes } from '../../../lib/emailTemplates';

const iconFor = (type = '') => (type.startsWith('image/') ? ImageIcon : /sheet|csv|excel/.test(type) ? FileSpreadsheet : FileText);

export const AttachmentChips = ({ items, onRemove, testId = 'compose-attachment' }) => {
  if (!items.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={`${testId}-list`}>
      {items.map((a, i) => {
        const Icon = iconFor(a.content_type);
        return (
          <span key={`${a.filename}-${i}`} className="inline-flex items-center gap-1.5 rounded-md border border-neutral-200 bg-neutral-50 pl-2 pr-1 py-1 text-[11px]" data-testid={testId}>
            <Icon className="w-3.5 h-3.5 text-amber-600" />
            <span className="max-w-[180px] truncate">{a.filename}</span>
            <span className="text-neutral-400">{fmtBytes(a.size)}</span>
            {onRemove && <button type="button" onClick={() => onRemove(i)} className="p-0.5 rounded hover:bg-white text-neutral-500" aria-label="Remove attachment"><X className="w-3 h-3" /></button>}
          </span>
        );
      })}
    </div>
  );
};

export default AttachmentChips;
